import React, { Component } from 'react'
import { Route, BrowserRouter } from 'react-router-dom'

import * as routes from './routes'

import Home from './Home'
import Store from './Store'
import Navigation from './Navigation'
import VideoUpload from './VideoUpload'
import VideoStatus from './VideoStatus'
import Success from './Success'
import Crypto from './Crypto'
import Profile from './Profile'
import Auth from './Auth'
import Likes from './Likes'

import './App.css'

class App extends Component {
  render = () =>
    <BrowserRouter>
      <Navigation />
      <Route exact path={[routes.HOME, routes.VIDEO]} component={Home} />
      <Route exact path={[routes.LIKES, routes.LIKES_VID]} component={Likes} />
      <Route exact path={[routes.PROFILE, routes.PROFILE_VID]} component={Profile} />
      <Route exact path={routes.STORE} component={Store} />
      <Route exact path={routes.UPLOAD} component={VideoUpload} />
      <Route exact path={routes.VIDEO_STATUS} component={VideoStatus} />
      <Route exact path={routes.MAGIC_LOGIN} component={Auth} />
      <Route exact path={routes.SUCCESS} component={Success} />
      <Route exact path={routes.CRYPTO} component={Crypto} />
    </BrowserRouter>
}


export default App
